(function () {
  function easeOutCubic(p) {
    return 1 - Math.pow(1 - p, 3);
  }

  function countTo(el, target, duration) {
    var start = performance.now();
    function step(now) {
      var p = Math.min(1, (now - start) / duration);
      var eased = easeOutCubic(p);
      var value = Math.round(eased * target);
      el.textContent = value.toLocaleString('en-GB') + ' pages';
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initWhySwitchYield(container) {
    var bars = container.querySelectorAll('[data-why-switch-yield-bar]');
    if (!bars.length) return;
    var animated = false;


    function run() {
      if (animated) return;
      animated = true;
      bars.forEach(function (bar) {
        var target = parseInt(bar.getAttribute('data-target'), 10) || 0;
        var row = bar.closest('.why-switch__yield-row');
        var countEl = row ? row.querySelector('[data-why-switch-yield-count]') : null;
        requestAnimationFrame(function () {
          bar.classList.add('is-grown');
        });
        if (countEl) countTo(countEl, target, 1400);
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) run();
          });
        },
        { threshold: 0.4 }
      );
      observer.observe(container);
    } else {
      run();
    }
  }

  /* Starts each page-count block once. Also picks up blocks added later - the colour picker swaps in another
     product without a page load, and without this its numbers stayed at "0 pages". */
  function initAll() {
    document.querySelectorAll('[data-why-switch-yield-bars]:not([data-ws-init])').forEach(function (container) {
      /* While the page is still loading the block can appear before its bars do - wait until they are there. */
      if (!container.querySelector('[data-why-switch-yield-bar]')) return;
      if (document.readyState === 'loading' && !container.nextElementSibling) return;
      container.setAttribute('data-ws-init', '');
      initWhySwitchYield(container);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  if (!window.__wsYieldObserver && 'MutationObserver' in window) {
    window.__wsYieldObserver = new MutationObserver(initAll);
    var startObserver = function () {
      window.__wsYieldObserver.observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) startObserver();
    else document.addEventListener('DOMContentLoaded', startObserver);
  }
})();
